import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { getServiceIdSelector } from '../../user/selectors'
import { DrainService } from '../../procedures/drain/services/drain.service'
import * as actions from '../store/options.actions'

export function* setDrainChestSuctionOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const drainService = new DrainService(serviceId)
  try {
    const response: IOptionsResponse = yield call([drainService, drainService.getChestSuctionOptions])
    const { entity } = response
    yield put(actions.setDrainChestSuctionOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`setDrainChestSuctionOptions() error: ${e}`))
  }
}
export function* setDrainChestSuctionOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setDrainChestSuctionOptions)
}
